import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, REQUIRED } from "./utils";
import * as BULGARIA from "pages/employer-of-record/onboarding/profile-info/form/bg/constants.bg";
import { taxIdFieldConfig } from "./_common";

export const bulgariaFields = {
  bgEgn: taxIdFieldConfig("BG", "bgEgn"),
  bgGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "bgGender",
    label: "Gender",
    placeholder: "Select Gender",
    options: BULGARIA.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgDisabilityStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "bgDisabilityStatus",
    label: "Disability Status",
    placeholder: "Select Disability Status",
    message:
      'Please select "Yes" if you have an officially certified permanent disability under Bulgarian law.',
    options: BULGARIA.DISABILITY_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgIdCardNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "bgIdCardNumber",
    label: "Passport / ID Card Number",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgIdCardDateOfIssue: field({
    type: FieldTypes.date,
    informationType: "identification",
    name: "bgIdCardDateOfIssue",
    label: "Passport / ID Card Date of Issue",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgIdCardIssuedBy: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "bgIdCardIssuedBy",
    label: "Passport / ID Card Issued By",
    message:
      "Please enter the Authority that your ID Card or Passport is issued by, e.g. Ministry of Interior - Bulgaria",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgEducationLevel: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "bgEducationLevel",
    label: "Highest Level of Education Completed",
    placeholder: "Select Education Level",
    options: BULGARIA.EDUCATION_LEVEL_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgAcademicDegree: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "bgAcademicDegree",
    label: "Academic Degree",
    message:
      "Please enter the academic degree as stated on your higher education diploma (e.g., Bachelor, Master, PhD). If you do not have a higher education degree, put in N/A.",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
  bgMajorSpecialty: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "bgMajorSpecialty",
    label: "Major / Specialty",
    message:
      "Please enter your field of study exactly as stated on your diploma (e.g., Computer Science, Economics, Mechanical Engineering).",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("BG"),
    },
    value: () => "",
  }),
};
